if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.scale = 1;
      this.pointers = new Map();
      this.content = this.querySelector('.product-media-modal__content');
      // Keep clicks inside the viewer from triggering ModalDialog's close gesture.
      this.querySelector('[role="dialog"]').addEventListener('pointerup', event => event.stopPropagation());
      const fr = document.documentElement.lang.startsWith('fr');
      this.labels = fr ? ['Image précédente', 'Dézoomer', 'Taille normale', 'Zoomer', 'Image suivante'] : ['Previous image', 'Zoom out', 'Reset zoom', 'Zoom in', 'Next image'];
      this.toolbar = document.createElement('div');
      this.toolbar.className = 'diy-gallery-toolbar';
      this.toolbar.setAttribute('role', 'group');
      this.toolbar.setAttribute('aria-label', fr ? 'Navigation et zoom' : 'Image navigation and zoom');
      this.buttons = this.labels.map((label, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.setAttribute('aria-label', label);
        button.textContent = ['‹', '−', '100 %', '+', '›'][index];
        button.addEventListener('click', () => {
          if (index === 0 || index === 4) this.navigate(index === 0 ? -1 : 1);
          else this.zoom(index === 2 ? 1 : this.scale + (index === 1 ? -.5 : .5));
        });
        this.toolbar.append(button); return button;
      });
      this.counter = document.createElement('span');
      this.counter.className = 'diy-gallery-counter';
      this.counter.setAttribute('aria-live', 'polite');
      this.toolbar.append(this.counter);
      this.content.before(this.toolbar);
      this.content.addEventListener('click', event => {
        if (this.dragged) { this.dragged = false; return; }
        if (event.target === this.activeMedia || this.pointerTarget === this.activeMedia) this.zoom(this.scale > 1 ? 1 : 2);
        else if (event.target === this.content) this.hide();
      });
      this.addEventListener('keydown', event => {
        if (event.target.closest('input,textarea,select')) return;
        if (['ArrowLeft', 'ArrowRight', '+', '=', '-', '0'].includes(event.key)) {
          event.preventDefault();
          if (event.key.startsWith('Arrow')) this.navigate(event.key === 'ArrowLeft' ? -1 : 1);
          else this.zoom(event.key === '0' ? 1 : this.scale + (event.key === '-' ? -.5 : .5));
        }
      });
      this.content.addEventListener('wheel', event => {
        if (!event.ctrlKey) return;
        event.preventDefault(); this.zoom(this.scale + (event.deltaY < 0 ? .2 : -.2), {x:event.clientX,y:event.clientY});
      }, {passive:false});
      this.content.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.pointers.set(event.pointerId, {x:event.clientX,y:event.clientY});
        this.start = {x:event.clientX,y:event.clientY}; this.pointerTarget = event.target; this.dragged = false;
        this.content.setPointerCapture(event.pointerId);
      });
      this.content.addEventListener('pointermove', event => {
        const previous = this.pointers.get(event.pointerId); if (!previous) return;
        const before = [...this.pointers.values()];
        this.pointers.set(event.pointerId, {x:event.clientX,y:event.clientY});
        const after = [...this.pointers.values()];
        if (after.length === 2) {
          const distance = points => Math.hypot(points[0].x-points[1].x,points[0].y-points[1].y);
          const oldDistance = distance(before);
          if (oldDistance > 0) this.zoom(this.scale * distance(after)/oldDistance, {x:(after[0].x+after[1].x)/2,y:(after[0].y+after[1].y)/2});
          this.dragged = true;
        } else if (this.scale > 1) {
          this.content.scrollLeft += previous.x-event.clientX;
          this.content.scrollTop += previous.y-event.clientY;
        }
        if (Math.hypot(event.clientX-this.start.x,event.clientY-this.start.y)>8) this.dragged = true;
      });
      this.content.addEventListener('pointerup', event => {
        if (!this.pointers.has(event.pointerId)) return;
        const dx = event.clientX-this.start.x, dy = event.clientY-this.start.y;
        if (this.pointers.size === 1 && this.scale === 1 && Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) this.navigate(dx<0 ? 1 : -1);
        this.pointers.delete(event.pointerId);
      });
      this.content.addEventListener('pointercancel', event => this.pointers.delete(event.pointerId));
      this.content.addEventListener('dragstart', event => event.preventDefault());
      this.resize = new ResizeObserver(() => { if (this.hasAttribute('open')) this.render(); });
      this.resize.observe(this.content);
    }
    media() { return [...this.content.querySelectorAll('[data-media-id]')]; }
    show(opener) {
      const media = this.media().find(image => image.dataset.mediaId === opener.dataset.mediaId);
      if (!media) return;
      super.show(opener); this.activate(media);
    }
    hide() {
      this.scale = 1; this.pointers.clear();
      super.hide();
    }
    activate(media) {
      this.activeMedia = media; this.scale = 1; this.pointers.clear();
      this.media().forEach(image => image.classList.toggle('active',image === media));
      this.content.scrollTo({left:0,top:0,behavior:'instant'});
      if (media.tagName === 'IMG') {
        media.addEventListener('load', () => { if (this.activeMedia === media) this.render(); }, {once:true});
      } else media.loadContent?.();
      this.render();
    }
    navigate(direction) {
      const images = this.media(), index = images.indexOf(this.activeMedia);
      const next = images[(index+direction+images.length)%images.length];
      if (!next) return;
      this.activate(next);
      const galleries = [...document.querySelectorAll('media-gallery')];
      for (const gallery of galleries) {
        const item = [...gallery.querySelectorAll('[data-media-id]')].find(item => item.dataset.mediaId.endsWith('-'+next.dataset.mediaId));
        if (item) { gallery.setActiveMedia(item.dataset.mediaId,false); this.openedBy = item.querySelector('.product__media-toggle') || this.openedBy; break; }
      }
    }
    zoom(value, point) {
      if (this.activeMedia?.tagName !== 'IMG') return;
      const old = this.scale;
      this.scale = Math.max(1,Math.min(4,value));
      const rect = this.content.getBoundingClientRect();
      const x = point ? point.x-rect.left : this.content.clientWidth/2;
      const y = point ? point.y-rect.top : this.content.clientHeight/2;
      const left = this.content.scrollLeft, top = this.content.scrollTop;
      this.render();
      this.content.scrollLeft = this.scale === 1 ? 0 : (left+x)*this.scale/old-x;
      this.content.scrollTop = this.scale === 1 ? 0 : (top+y)*this.scale/old-y;
    }
    render() {
      const image = this.activeMedia; if (!image) return;
      if (image.tagName === 'IMG') {
        const ratio = (image.naturalWidth||image.width)/(image.naturalHeight||image.height);
        const height = Math.min(this.content.clientHeight-24,(this.content.clientWidth-24)/ratio);
        image.style.width = Math.round(height*ratio*this.scale)+'px';
        image.style.height = Math.round(height*this.scale)+'px';
        image.style.cursor = this.scale > 1 ? 'zoom-out' : 'zoom-in';
      }
      this.buttons[2].textContent = Math.round(this.scale*100)+' %';
      this.buttons[1].disabled = this.scale === 1;
      this.buttons[3].disabled = this.scale === 4;
      this.buttons[0].disabled = this.buttons[4].disabled = this.media().length < 2;
      this.counter.textContent = (this.media().indexOf(image)+1)+' / '+this.media().length;
    }
  });
}
